import { render, staticRenderFns } from "./GoalsHistoryPanel.vue?vue&type=template&id=d6b2ddd4&lang=pug&"
import script from "./GoalsHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./GoalsHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoalsHistoryPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports